import { AssetTransfer } from './asset-transfer';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';



export class AssetTransferLine extends BaseEntity {

  assetTransfer     : AssetTransfer = new AssetTransfer();
  assetProduct      : AssetProduct = new AssetProduct();
  available         : number;
  quantity          : number;
  assets            : Asset[] = [];

  // for Asset reception use 
  //----------------------------------------
  expectedQuantity  : number;
  barCode           : string;
  rejectionReason   : string;
  shrinkMode        : boolean = true;

  rejectedAssetsNumber : number =0;
  acceptedAssetsNumber : number =0;
  assignedAssetsNumber : number =0;
//----------------------------------------
 
  constructor() {
    super();

  }
}